import React, { Component } from "react";
import PaySelect from "Molecules/PaySelect";
import Policies from "Molecules/Policies";
import Caret from "Atoms/Caret";
import AccountNumber from "Atoms/AccountNumber";
import ReadOnlyPrice from "Atoms/ReadOnlyPrice";
import TextField from "Atoms/TextField";
import Currency from 'react-currency-formatter';
import moment from 'moment';
import Tag from "../../atoms/Tag/Tag";



export default class AccountItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isPaySelectOpen: false,
			classes: "billing-accounts-item",
		};
		this.togglePaySelect = this.togglePaySelect.bind(this);
		this.closePaySelect = this.closePaySelect.bind(this);
	}

	togglePaySelect = () => {
		window._satellite && window._satellite.track('totalsummary')
		if (this.state.isPaySelectOpen) {
			this.props.hidePayVeil();
			this.setState({
				classes: "billing-accounts-item",
				isPaySelectOpen: false
			});
		} else {
			this.props.showPayVeil();
			this.setState({
				classes: this.state.classes + " payselect-is-visible",
				isPaySelectOpen: true
			});
		}
	}


	paySelectKeyUpToggle = event => {
		if (event.keyCode === 13) {
			this.togglePaySelect();
		} else if (event.keyCode === 27) {
			this.props.hidePayVeil();
			this.setState({
				classes: "billing-accounts-item",
				isPaySelectOpen: false
			});
		}
	}

	closePaySelect(){
		this.setState({
			isPaySelectOpen: false,
			classes: "billing-accounts-item"
		});
	}

	openPayModalKeyUp(e) {
		if (e.keyCode === 13) {
      this.props.openPayModal(this.props.accountData.account_number);
		}
	}

	renderMessages = (reoccuringPaymentIndicator,minimum_due_date,finalDate,pastDueIncludedIndicator) =>{
		

		if ((minimum_due_date == null) && !reoccuringPaymentIndicator){
			return (
				<div className="payment-due-date">
				  Minimum Due
				</div>
			)
		}


  		else if (reoccuringPaymentIndicator && !pastDueIncludedIndicator){
			return (
				<div className="payment-due-date">
						Autopay enabled
				</div>
			)
		}
		else if (reoccuringPaymentIndicator && pastDueIncludedIndicator){
			return (
				<div className="payment-additional-info">
					Autopay failed, please contact support
				</div>
			)
		}
		else {
			return (
				<div className="payment-due-date">
					{`Minimum due by ${finalDate}`}
				</div>
			)
		}
	}
	check = (conditions) => {
		return (conditions)	? true : false;
	
	}

	checkPastDueIncluded = (pastDueIncludedIndicator,payment_amount) => {
		return pastDueIncludedIndicator && payment_amount>0;
	}
	renderPaymentInfoMessage = () => {
		let { minimum_due_amount, past_due_amount, recurring_enabled, paymentOption, minimum_due_date } = this.props.accountData;
		//check for reoccuring payments
		let reoccuringPaymentIndicator = this.check(recurring_enabled);

		//check if there is a past due amount
		let pastDueIncludedIndicator = this.check(past_due_amount > 0);
		let finalDate;

		if(minimum_due_date != null){
			//TIME CODE: https://stackoverflow.com/questions/36206260/how-to-set-date-always-to-eastern-time-regardless-of-users-time-zone
			let dateArray = minimum_due_date.split(/[^0-9]/);
			let dueDate = new Date(dateArray[0], dateArray[1] - 1 , dateArray[2]);
			finalDate = moment(dueDate).format('MMM DD, YYYY');
		}

		if(paymentOption && paymentOption !== "min"){
			let {payment_amount}=this.props.accountData;
			return (
				<div>
					<div className="payment-due-date">
						{paymentOption}
					</div>
					{this.checkPastDueIncluded(pastDueIncludedIndicator, payment_amount) && <div className="payment-additional-info">Past due included</div>}
				</div>
			)
		}

		if ((minimum_due_date !== null) && !reoccuringPaymentIndicator && (past_due_amount > 0)){
				return (
				<div>
					<div className="payment-due-date">
						{`Minimum due by ${finalDate}`}
					</div>

					<div className="payment-additional-info">
						Past due included
					</div>
					</div>
				)
			}
			if(minimum_due_amount === 0 && !reoccuringPaymentIndicator){
				return (
					<div className="payment-due-date"></div>
				)
			}

		return this.renderMessages(reoccuringPaymentIndicator,minimum_due_date,finalDate,pastDueIncludedIndicator);

	}



	handleAccountNumberClick = () => {
		this.props.openPayModal(this.props.accountData.account_number);
	}

	checkCancelled = (policies) => {
		if(policies===undefined){
			return false;
		  }
		const cancelledPolicies = policies.filter(el => {
			if(el.policy_status!==null && el.policy_status!==undefined){
				return el.policy_status.toLowerCase().includes("cancellation pending");
			}
			return false;
		});
		return cancelledPolicies.length>0;
	}

	render() {
		let {
			mobileViewToggle, index,
			accountData: {product_code,policies,payment_amount,account_number,minimum_due_amount,pay_in_full_amount,past_due_amount,recurring_enabled}
		 } = this.props;

		let summaryAccountData = minimum_due_amount;

		if(payment_amount >= 0){
			summaryAccountData = payment_amount;
		} else if(recurring_enabled && past_due_amount > 0){
			summaryAccountData = minimum_due_amount;
		} else if((recurring_enabled && past_due_amount === 0)){
			summaryAccountData = 0;
		}

		const containsCancelledPolicies=this.checkCancelled(policies);
		return (
			<div className={this.state.classes}>
				<div className="paysummary">
					<div className="dx-col">
						<div className="group">
							<div className="row account">
								<div className="dx-col" onClick={this.handleAccountNumberClick} onKeyUp={(e)=>{this.openPayModalKeyUp(e)}}>
									<a className={`goto-details`} id={`details-${index}`} onClick={this.handleAccountNumberClick}><Caret /></a>
									<div className="label">
										{" "}Billing Account{" "}
									</div>
									<div style={{"display": "flex","align-items": "center"}}>
										<div aria-label="Billing Account Number" className={`content accNumInfo${account_number}`} tabIndex="0">
											{" "} <AccountNumber accountNumber={account_number} />{" "}
										</div>
										{product_code==="RSCIA" &&<Tag text={"RSCIA"}/>}
										{containsCancelledPolicies && <Tag text={"Cancellation Pending"}/>}
									</div>
								</div>
							</div>
							<Policies policies={policies} showAmount={mobileViewToggle} />
						</div>


						<div className="group">
							<div className="row total">
								<div className="dx-col">
									<div className="payment-total is-readonly">
										<div className="element readonly">
											<span> <Currency quantity={summaryAccountData} pattern="!#,##0.00" /></span>
										</div>
										<div className="element editable">
											<div className="element readonly">
												<span>
													<ReadOnlyPrice price={"2000"} />
												</span>
											</div>

											<TextField placeholder="Full Amount" id="billing" maskType="dollars" value={pay_in_full_amount} />
										</div>
									</div>


									{ this.renderPaymentInfoMessage() }


								</div>
							</div>
						</div>
					</div>

					<div
						onClick={this.togglePaySelect}
						className="payselect-trigger"
						tabIndex="0"
						onKeyUp={this.paySelectKeyUpToggle}>
						<span className="Caret" >
							<svg
								width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
								<path d="M16.333 13.667L9.667 7 3 13.667z" strokeWidth="2" fillRule="evenodd"/>
							</svg>
						</span>
					</div>

					<PaySelect account={this.props.accountData} index = {this.props.index} closeHandler={this.togglePaySelect}/>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/AccountItem/AccountItem.js